export default __webpack_public_path__ + "static/headerPicture@2x-c8a3a3e5478153d0701c9b2b0270f6e9.png";